var map = {
	"./arrow-up.svg": 47564,
	"./bullets--hover.svg": 29944,
	"./bullets.svg": 46437,
	"./check-icon.svg": 30529,
	"./damixa-logo-market.svg": 23927,
	"./drop-down-learning.svg": 6104,
	"./file.svg": 54644,
	"./footer-ampm.svg": 3699,
	"./footer-damixa.svg": 63445,
	"./footer-dorff.svg": 46412,
	"./icon-360.svg": 90993,
	"./icon-accessories.svg": 20912,
	"./icon-accessory.svg": 85941,
	"./icon-add-favorite.svg": 76533,
	"./icon-add.svg": 70357,
	"./icon-ampm.svg": 18117,
	"./icon-arrow-filter.svg": 13682,
	"./icon-attention.svg": 2786,
	"./icon-award-bigsee.svg": 89169,
	"./icon-award-good.svg": 44276,
	"./icon-award-iconic.svg": 58044,
	"./icon-award-if.svg": 67010,
	"./icon-award-reddot.svg": 10353,
	"./icon-back-learning.svg": 98256,
	"./icon-back.svg": 19597,
	"./icon-bath.svg": 53721,
	"./icon-bonus-motivation.svg": 44809,
	"./icon-bonus.svg": 25933,
	"./icon-box.svg": 56566,
	"./icon-calendar.svg": 39572,
	"./icon-call.svg": 54440,
	"./icon-car.svg": 17403,
	"./icon-carousel-arrow.svg": 55689,
	"./icon-cart.svg": 16368,
	"./icon-catalogue-mob.svg": 37654,
	"./icon-catalogue.svg": 93906,
	"./icon-ceramics.svg": 76390,
	"./icon-chart-down.svg": 48500,
	"./icon-circle-success.svg": 4684,
	"./icon-close-16px.svg": 92475,
	"./icon-close-learning.svg": 63474,
	"./icon-close-mini.svg": 50946,
	"./icon-close.svg": 60453,
	"./icon-code.svg": 24528,
	"./icon-colors.svg": 95089,
	"./icon-compare.svg": 89051,
	"./icon-copy.svg": 91305,
	"./icon-credit.svg": 97996,
	"./icon-damixa.svg": 41644,
	"./icon-dash.svg": 28996,
	"./icon-dd-arrow.svg": 12531,
	"./icon-delivery.svg": 76921,
	"./icon-design.svg": 21902,
	"./icon-discount.svg": 57195,
	"./icon-dislike.svg": 86101,
	"./icon-docs.svg": 75147,
	"./icon-dorff.svg": 24733,
	"./icon-download.svg": 40164,
	"./icon-dropdown.svg": 29398,
	"./icon-eco.svg": 33207,
	"./icon-edit.svg": 48782,
	"./icon-email.svg": 91989,
	"./icon-error-motivation.svg": 785,
	"./icon-error.svg": 12078,
	"./icon-everlast.svg": 53554,
	"./icon-externallink.svg": 19018,
	"./icon-facebook.svg": 41695,
	"./icon-faucets.svg": 59172,
	"./icon-favorite-mini.svg": 54088,
	"./icon-favourite-motivation.svg": 97704,
	"./icon-file.svg": 49206,
	"./icon-flame.svg": 63023,
	"./icon-footer-logo.svg": 1680,
	"./icon-furniture.svg": 25823,
	"./icon-gift-incircle.svg": 25876,
	"./icon-gift.svg": 83054,
	"./icon-good.svg": 81900,
	"./icon-guarantee.svg": 22176,
	"./icon-header-damixa.svg": 13620,
	"./icon-header-dorff.svg": 89431,
	"./icon-heart-active.svg": 67479,
	"./icon-heart-mini.svg": 67019,
	"./icon-heart.svg": 84719,
	"./icon-hide.svg": 1809,
	"./icon-home.svg": 79864,
	"./icon-inspire.svg": 17305,
	"./icon-instagram.svg": 71532,
	"./icon-instock.svg": 67134,
	"./icon-level-1-disabled.svg": 85283,
	"./icon-level-1.svg": 33946,
	"./icon-level-10-disabled.svg": 28675,
	"./icon-level-10.svg": 68494,
	"./icon-level-2-disabled.svg": 85767,
	"./icon-level-2.svg": 71251,
	"./icon-level-3-disabled.svg": 68447,
	"./icon-level-3.svg": 64599,
	"./icon-level-4-disabled.svg": 20966,
	"./icon-level-4.svg": 43907,
	"./icon-level-5-disabled.svg": 91166,
	"./icon-level-5.svg": 13796,
	"./icon-level-6-disabled.svg": 60249,
	"./icon-level-6.svg": 24731,
	"./icon-level-7-disabled.svg": 54018,
	"./icon-level-7.svg": 68871,
	"./icon-level-8-disabled.svg": 29106,
	"./icon-level-8.svg": 57104,
	"./icon-level-9-disabled.svg": 58591,
	"./icon-level-9.svg": 48364,
	"./icon-like.svg": 86274,
	"./icon-login.svg": 13155,
	"./icon-logo.svg": 3590,
	"./icon-logout.svg": 38999,
	"./icon-map.svg": 23034,
	"./icon-menu.svg": 18551,
	"./icon-minus.svg": 85473,
	"./icon-mixer.svg": 17370,
	"./icon-myGoods.svg": 85784,
	"./icon-myblue.svg": 11868,
	"./icon-mypurple.svg": 72594,
	"./icon-myred.svg": 66711,
	"./icon-nav-arrow.svg": 87427,
	"./icon-negative.svg": 14839,
	"./icon-next.svg": 84867,
	"./icon-not-passed.svg": 99005,
	"./icon-notebook.svg": 25557,
	"./icon-outofstock.svg": 21188,
	"./icon-passed.svg": 52534,
	"./icon-pc.svg": 73655,
	"./icon-phone.svg": 5511,
	"./icon-play.svg": 71892,
	"./icon-plus.svg": 44722,
	"./icon-positive.svg": 78279,
	"./icon-prev.svg": 326,
	"./icon-pushtoopen.svg": 33174,
	"./icon-question.svg": 69318,
	"./icon-red-error.svg": 48939,
	"./icon-red.svg": 38827,
	"./icon-redo.svg": 937,
	"./icon-refresh.svg": 8725,
	"./icon-required.svg": 75966,
	"./icon-return.svg": 88033,
	"./icon-rsu.svg": 99573,
	"./icon-rub.svg": 95189,
	"./icon-ruble.svg": 18775,
	"./icon-sad-heart.svg": 30433,
	"./icon-sadheart.svg": 34950,
	"./icon-search.svg": 49689,
	"./icon-see.svg": 79271,
	"./icon-send-motivation.svg": 18237,
	"./icon-send.svg": 47656,
	"./icon-set.svg": 62059,
	"./icon-settings.svg": 98942,
	"./icon-share.svg": 9339,
	"./icon-shop.svg": 85605,
	"./icon-show.svg": 78060,
	"./icon-shower.svg": 23407,
	"./icon-slim-gradient-gift.svg": 36714,
	"./icon-smartphone.svg": 51847,
	"./icon-sms-motivation.svg": 60977,
	"./icon-sms.svg": 93703,
	"./icon-sort-both.svg": 70193,
	"./icon-sort-table.svg": 90606,
	"./icon-sort.svg": 340,
	"./icon-sphere.svg": 81263,
	"./icon-ssu.svg": 44351,
	"./icon-start-learning.svg": 92976,
	"./icon-start.svg": 83,
	"./icon-stock.svg": 31780,
	"./icon-storage.svg": 6357,
	"./icon-success-40px.svg": 28009,
	"./icon-success-disabled-motivation.svg": 93128,
	"./icon-success-motivation.svg": 87640,
	"./icon-success.svg": 42239,
	"./icon-telephone.svg": 29380,
	"./icon-time-motivation.svg": 24727,
	"./icon-time.svg": 80175,
	"./icon-toilet.svg": 6740,
	"./icon-touch.svg": 61453,
	"./icon-touchreel.svg": 44114,
	"./icon-transfer.svg": 60202,
	"./icon-trash.svg": 72140,
	"./icon-user.svg": 89012,
	"./icon-video.svg": 96105,
	"./icon-videocall.svg": 87316,
	"./icon-vkontakte.svg": 81592,
	"./icon-wellness.svg": 36042,
	"./icon-youtube.svg": 49469,
	"./icon-youtube2.svg": 28196,
	"./icon-youtubeplay-learning.svg": 63003,
	"./icon-zoom.svg": 80346,
	"./location-pin.svg": 11246,
	"./logo-market.svg": 84698,
	"./logo-white.svg": 47227,
	"./logo.svg": 95657,
	"./next-arrow-learning.svg": 30465,
	"./tab-completed-learning.svg": 86276,
	"./time-icon.svg": 69422,
	"./youtubeplay-grey.svg": 3492,
	"src/icons/arrow-up.svg": 47564,
	"src/icons/bullets--hover.svg": 29944,
	"src/icons/bullets.svg": 46437,
	"src/icons/check-icon.svg": 30529,
	"src/icons/damixa-logo-market.svg": 23927,
	"src/icons/drop-down-learning.svg": 6104,
	"src/icons/file.svg": 54644,
	"src/icons/footer-ampm.svg": 3699,
	"src/icons/footer-damixa.svg": 63445,
	"src/icons/footer-dorff.svg": 46412,
	"src/icons/icon-360.svg": 90993,
	"src/icons/icon-accessories.svg": 20912,
	"src/icons/icon-accessory.svg": 85941,
	"src/icons/icon-add-favorite.svg": 76533,
	"src/icons/icon-add.svg": 70357,
	"src/icons/icon-ampm.svg": 18117,
	"src/icons/icon-arrow-filter.svg": 13682,
	"src/icons/icon-attention.svg": 2786,
	"src/icons/icon-award-bigsee.svg": 89169,
	"src/icons/icon-award-good.svg": 44276,
	"src/icons/icon-award-iconic.svg": 58044,
	"src/icons/icon-award-if.svg": 67010,
	"src/icons/icon-award-reddot.svg": 10353,
	"src/icons/icon-back-learning.svg": 98256,
	"src/icons/icon-back.svg": 19597,
	"src/icons/icon-bath.svg": 53721,
	"src/icons/icon-bonus-motivation.svg": 44809,
	"src/icons/icon-bonus.svg": 25933,
	"src/icons/icon-box.svg": 56566,
	"src/icons/icon-calendar.svg": 39572,
	"src/icons/icon-call.svg": 54440,
	"src/icons/icon-car.svg": 17403,
	"src/icons/icon-carousel-arrow.svg": 55689,
	"src/icons/icon-cart.svg": 16368,
	"src/icons/icon-catalogue-mob.svg": 37654,
	"src/icons/icon-catalogue.svg": 93906,
	"src/icons/icon-ceramics.svg": 76390,
	"src/icons/icon-chart-down.svg": 48500,
	"src/icons/icon-circle-success.svg": 4684,
	"src/icons/icon-close-16px.svg": 92475,
	"src/icons/icon-close-learning.svg": 63474,
	"src/icons/icon-close-mini.svg": 50946,
	"src/icons/icon-close.svg": 60453,
	"src/icons/icon-code.svg": 24528,
	"src/icons/icon-colors.svg": 95089,
	"src/icons/icon-compare.svg": 89051,
	"src/icons/icon-copy.svg": 91305,
	"src/icons/icon-credit.svg": 97996,
	"src/icons/icon-damixa.svg": 41644,
	"src/icons/icon-dash.svg": 28996,
	"src/icons/icon-dd-arrow.svg": 12531,
	"src/icons/icon-delivery.svg": 76921,
	"src/icons/icon-design.svg": 21902,
	"src/icons/icon-discount.svg": 57195,
	"src/icons/icon-dislike.svg": 86101,
	"src/icons/icon-docs.svg": 75147,
	"src/icons/icon-dorff.svg": 24733,
	"src/icons/icon-download.svg": 40164,
	"src/icons/icon-dropdown.svg": 29398,
	"src/icons/icon-eco.svg": 33207,
	"src/icons/icon-edit.svg": 48782,
	"src/icons/icon-email.svg": 91989,
	"src/icons/icon-error-motivation.svg": 785,
	"src/icons/icon-error.svg": 12078,
	"src/icons/icon-everlast.svg": 53554,
	"src/icons/icon-externallink.svg": 19018,
	"src/icons/icon-facebook.svg": 41695,
	"src/icons/icon-faucets.svg": 59172,
	"src/icons/icon-favorite-mini.svg": 54088,
	"src/icons/icon-favourite-motivation.svg": 97704,
	"src/icons/icon-file.svg": 49206,
	"src/icons/icon-flame.svg": 63023,
	"src/icons/icon-footer-logo.svg": 1680,
	"src/icons/icon-furniture.svg": 25823,
	"src/icons/icon-gift-incircle.svg": 25876,
	"src/icons/icon-gift.svg": 83054,
	"src/icons/icon-good.svg": 81900,
	"src/icons/icon-guarantee.svg": 22176,
	"src/icons/icon-header-damixa.svg": 13620,
	"src/icons/icon-header-dorff.svg": 89431,
	"src/icons/icon-heart-active.svg": 67479,
	"src/icons/icon-heart-mini.svg": 67019,
	"src/icons/icon-heart.svg": 84719,
	"src/icons/icon-hide.svg": 1809,
	"src/icons/icon-home.svg": 79864,
	"src/icons/icon-inspire.svg": 17305,
	"src/icons/icon-instagram.svg": 71532,
	"src/icons/icon-instock.svg": 67134,
	"src/icons/icon-level-1-disabled.svg": 85283,
	"src/icons/icon-level-1.svg": 33946,
	"src/icons/icon-level-10-disabled.svg": 28675,
	"src/icons/icon-level-10.svg": 68494,
	"src/icons/icon-level-2-disabled.svg": 85767,
	"src/icons/icon-level-2.svg": 71251,
	"src/icons/icon-level-3-disabled.svg": 68447,
	"src/icons/icon-level-3.svg": 64599,
	"src/icons/icon-level-4-disabled.svg": 20966,
	"src/icons/icon-level-4.svg": 43907,
	"src/icons/icon-level-5-disabled.svg": 91166,
	"src/icons/icon-level-5.svg": 13796,
	"src/icons/icon-level-6-disabled.svg": 60249,
	"src/icons/icon-level-6.svg": 24731,
	"src/icons/icon-level-7-disabled.svg": 54018,
	"src/icons/icon-level-7.svg": 68871,
	"src/icons/icon-level-8-disabled.svg": 29106,
	"src/icons/icon-level-8.svg": 57104,
	"src/icons/icon-level-9-disabled.svg": 58591,
	"src/icons/icon-level-9.svg": 48364,
	"src/icons/icon-like.svg": 86274,
	"src/icons/icon-login.svg": 13155,
	"src/icons/icon-logo.svg": 3590,
	"src/icons/icon-logout.svg": 38999,
	"src/icons/icon-map.svg": 23034,
	"src/icons/icon-menu.svg": 18551,
	"src/icons/icon-minus.svg": 85473,
	"src/icons/icon-mixer.svg": 17370,
	"src/icons/icon-myGoods.svg": 85784,
	"src/icons/icon-myblue.svg": 11868,
	"src/icons/icon-mypurple.svg": 72594,
	"src/icons/icon-myred.svg": 66711,
	"src/icons/icon-nav-arrow.svg": 87427,
	"src/icons/icon-negative.svg": 14839,
	"src/icons/icon-next.svg": 84867,
	"src/icons/icon-not-passed.svg": 99005,
	"src/icons/icon-notebook.svg": 25557,
	"src/icons/icon-outofstock.svg": 21188,
	"src/icons/icon-passed.svg": 52534,
	"src/icons/icon-pc.svg": 73655,
	"src/icons/icon-phone.svg": 5511,
	"src/icons/icon-play.svg": 71892,
	"src/icons/icon-plus.svg": 44722,
	"src/icons/icon-positive.svg": 78279,
	"src/icons/icon-prev.svg": 326,
	"src/icons/icon-pushtoopen.svg": 33174,
	"src/icons/icon-question.svg": 69318,
	"src/icons/icon-red-error.svg": 48939,
	"src/icons/icon-red.svg": 38827,
	"src/icons/icon-redo.svg": 937,
	"src/icons/icon-refresh.svg": 8725,
	"src/icons/icon-required.svg": 75966,
	"src/icons/icon-return.svg": 88033,
	"src/icons/icon-rsu.svg": 99573,
	"src/icons/icon-rub.svg": 95189,
	"src/icons/icon-ruble.svg": 18775,
	"src/icons/icon-sad-heart.svg": 30433,
	"src/icons/icon-sadheart.svg": 34950,
	"src/icons/icon-search.svg": 49689,
	"src/icons/icon-see.svg": 79271,
	"src/icons/icon-send-motivation.svg": 18237,
	"src/icons/icon-send.svg": 47656,
	"src/icons/icon-set.svg": 62059,
	"src/icons/icon-settings.svg": 98942,
	"src/icons/icon-share.svg": 9339,
	"src/icons/icon-shop.svg": 85605,
	"src/icons/icon-show.svg": 78060,
	"src/icons/icon-shower.svg": 23407,
	"src/icons/icon-slim-gradient-gift.svg": 36714,
	"src/icons/icon-smartphone.svg": 51847,
	"src/icons/icon-sms-motivation.svg": 60977,
	"src/icons/icon-sms.svg": 93703,
	"src/icons/icon-sort-both.svg": 70193,
	"src/icons/icon-sort-table.svg": 90606,
	"src/icons/icon-sort.svg": 340,
	"src/icons/icon-sphere.svg": 81263,
	"src/icons/icon-ssu.svg": 44351,
	"src/icons/icon-start-learning.svg": 92976,
	"src/icons/icon-start.svg": 83,
	"src/icons/icon-stock.svg": 31780,
	"src/icons/icon-storage.svg": 6357,
	"src/icons/icon-success-40px.svg": 28009,
	"src/icons/icon-success-disabled-motivation.svg": 93128,
	"src/icons/icon-success-motivation.svg": 87640,
	"src/icons/icon-success.svg": 42239,
	"src/icons/icon-telephone.svg": 29380,
	"src/icons/icon-time-motivation.svg": 24727,
	"src/icons/icon-time.svg": 80175,
	"src/icons/icon-toilet.svg": 6740,
	"src/icons/icon-touch.svg": 61453,
	"src/icons/icon-touchreel.svg": 44114,
	"src/icons/icon-transfer.svg": 60202,
	"src/icons/icon-trash.svg": 72140,
	"src/icons/icon-user.svg": 89012,
	"src/icons/icon-video.svg": 96105,
	"src/icons/icon-videocall.svg": 87316,
	"src/icons/icon-vkontakte.svg": 81592,
	"src/icons/icon-wellness.svg": 36042,
	"src/icons/icon-youtube.svg": 49469,
	"src/icons/icon-youtube2.svg": 28196,
	"src/icons/icon-youtubeplay-learning.svg": 63003,
	"src/icons/icon-zoom.svg": 80346,
	"src/icons/location-pin.svg": 11246,
	"src/icons/logo-market.svg": 84698,
	"src/icons/logo-white.svg": 47227,
	"src/icons/logo.svg": 95657,
	"src/icons/next-arrow-learning.svg": 30465,
	"src/icons/tab-completed-learning.svg": 86276,
	"src/icons/time-icon.svg": 69422,
	"src/icons/youtubeplay-grey.svg": 3492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31249;